import { addBreadcrumb } from "@sentry/react";

type BreadcrumbCategory = "general" | "error";

export const breadcrumb = (
  message: string,
  category: BreadcrumbCategory = "general",
  // oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
  data?: Record<string, any>,
) => {
  addBreadcrumb({ category, level: "info", message, data });
};
